import React, { useEffect, useState } from "react";
import { makeStyles } from "@material-ui/core/styles";
import Breadcrumbs from "./Breadcrumbs";
import { useTheme } from "@material-ui/core/styles";
import useMediaQuery from "@material-ui/core/useMediaQuery";

const useStyles = makeStyles((theme) => ({
  root: {
    width: "100%",
    minHeight: 200,
    position: "relative",
    // paddingBottom: 55,
  },
  bg: {
    maxHeight: 205,
    minHeight: 205,
    width: "100%",
    position: "absolute",
    top: 0,
    zIndex: 1,
  },
  grid: {
    ...theme.grid.gridLg,
    position: "relative",
    zIndex: 2,
    [theme.breakpoints.down("sm")]: {
      width: "95%",
    },
  },
  cardTitle: {
    width: "100%",
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    color: "white",
    textAlign: "center",
  },
  title: {
    maxWidth: "600px",
    fontSize: theme.fontSize.xLarge,
    paddingBottom: 20,
    "& > h1 ": {
      height: 50,
      marginTop:15,
    },
    [theme.breakpoints.down("sm")]: {
      fontSize: theme.fontSize.xSmall,
    },
  },
  icon: {
    width: 17,
    height: 17,
    fill: "white",
  },
  bgImages: {
    width: '100%',
    minHeight: 200,
    backgroundSize: 'cover !important',
    backgroundRepeat: 'no-repeat !important',
    position: "absolute",
    zIndex: 1,
    top: 0,
    backgroundPosition: "center !important"
    // background:'url(/assets/images/stock-chart-1080.png)'
  }
}));

export default function Index() {
  const classes = useStyles();
  const [state, setstate] = useState("Services");

  const theme = useTheme();
  const matches = useMediaQuery(theme.breakpoints.down("sm"));

  const obj = {
    Services: {
      title: "خدمات کارگزاری  پویان ",
      Breadcrumbs: [
        { title: "خانه", link: "/" },
        {
          title: "خدمات",
          link: "/Services",
          bg: '/assets/images/newImages/'
        },
      ],
    },
    Forms: {
      title: "فرم‌های مشتریان",
      Breadcrumbs: [
        { title: "خانه", link: "/" },
        { title: "فرم ها", link: "/Forms" },
      ],
    },
    Investment: {
      title: "سرمایه‌گذاری",
      bg_lg: '/assets/images/newImages/Investment.jpg',
      bg_sm: '/assets/images/newImages/Investment414.jpg',
      Breadcrumbs: [
        { title: "خانه", link: "/" },
        { title: "سرمایه‌گذاری", link: "/Investment" },
      ],
    },
    Trades: {
      title: "معاملات",
      bg_lg: '/assets/images/newImages/Trades.jpg',
      bg_sm: '/assets/images/newImages/Trades414.jpg',
      Breadcrumbs: [
        { title: "خانه", link: "/" },
        { title: "معاملات", link: "/Trades" },
      ],
    },

    AboutUs: {
      title: "درباره  پویان ",
      bg_lg: '/assets/images/newImages/AboutUs.jpg',
      bg_sm: '/assets/images/newImages/AboutUs.jpg',
      // bg_sm: '/assets/images/newImages/AboutUs414.jpg',
      Breadcrumbs: [
        { title: "خانه", link: "/" },
        {
          title: "درباره پویان",
          link: "/AboutUs",
        },
      ],
    },
    Shoab: {
      title: "لیست شعب",
      bg_lg: '/assets/images/newImages/Shoab.jpg',
      bg_sm: '/assets/images/newImages/Shoab414.jpg',
      Breadcrumbs: [
        { title: "خانه", link: "/" },
        { title: "لیست شعب", link: "/Representation" },
      ],
    },
    AcountNumber: {
      title: "شماره حساب ها",
      bg_lg: '/assets/images/newImages/acountNumber.jpg',
      bg_sm: '/assets/images/newImages/acountNumber414.jpg',
      Breadcrumbs: [
        { title: "خانه", link: "/" },
        { title: "شماره حساب ها", link: "/AcountNumber" },
      ],
    },
    Boursekala: {
      title: 'بورس کالا',
      bg_lg: '/assets/images/newImages/kala.jpg',
      bg_sm: '/assets/images/newImages/kala.jpg',
      Breadcrumbs: [
        { title: 'خانه', link: '/' },
        { title: 'بورس کالا', link: '/Boursekala' },
      ]
    },
    news: {
      title: "اخبار",
      Breadcrumbs: [
        { title: "خانه", link: "/" },
        { title: "اخبار", link: "/News" },
      ],
    },
    NewsDetails: {
      title: "اخبار",
      Breadcrumbs: [
        { title: "خانه", link: "/" },
        { title: "اخبار", link: "/NewsDetails" },
      ],
    },
    MangementUsers: {
      title: "مدیران",
      bg_lg: '/assets/images/newImages/MangementUsers.jpg',
      bg_sm: '/assets/images/newImages/MangementUsers414.jpg',
      Breadcrumbs: [
        { title: "خانه", link: "/" },
        { title: "مدیران", link: "/MangementUsers" },
      ],
    },
    khodro: {
      title: "ثبت نام خرید خودرو",
      bg_lg: '/assets/images/newImages/khodro.jpg',
      bg_sm: '/assets/images/newImages/khodro414.jpg',
      Breadcrumbs: [
        { title: "خانه", link: "/" },
        { title: "ثبت نام خرید خودرو", link: "/khodro" },
      ],
    },
    ContactUs: {
      title: "مرکز تماس",
      bg_lg: '/assets/images/newImages/contactUs.jpg',
      bg_sm: '/assets/images/newImages/contactUs414.jpg',
      Breadcrumbs: [
        { title: "خانه", link: "/" },
        { title: "مرکز تماس", link: "/MangementUsers" },
      ],
    },
    energy: {
      title: "بورس انرژی",
      bg_lg: '/assets/images/newImages/energy.jpg',
      bg_sm: '/assets/images/newImages/energy414.jpg',
      Breadcrumbs: [
        { title: "خانه", link: "/" },
        { title: "بورس انرژی", link: "/energy" },
      ],
    },
    kala: {
      title: "بورس کالا",
      bg_lg: '/assets/images/newImages/kala.jpg',
      bg_sm: '/assets/images/newImages/kala414.jpg',
      Breadcrumbs: [
        { title: "خانه", link: "/" },
        { title: "بورس کالا", link: "/energy" },
      ],
    },
    faq: {
      title: "سوالات متداول",
      bg_lg: '/assets/images/newImages/faq.jpg',
      bg_sm: '/assets/images/newImages/faq414.jpg',
      Breadcrumbs: [
        { title: "خانه", link: "/" },
        { title: "سوالات متداول", link: "/faq" },
      ],
    },
    bourseKala: {
      title: "اطلاعیه‌های‌ عرضه کالا",
      Breadcrumbs: [
        { title: "خانه", link: "/" },
        { title: "اطلاعیه‌های‌ عرضه کالا", link: "/bourseKala" },
      ],
    },
    education: {
      title:'آموزش',
      bg_lg: '/assets/images/newImages/education.jpg',
      bg_sm: '/assets/images/newImages/education414.jpg',
      Breadcrumbs: [
        { title: "خانه", link: "/" },
        { title: "آموزش", link: "/bourseKala" },
      ],
    },
    deceased: {
      title:'انتقال سهام عدالت متوفیان',
      // bg_lg: '/assets/images/newImages/education.jpg',
      // bg_sm: '/assets/images/newImages/education414.jpg',
      Breadcrumbs: [
        { title: "خانه", link: "/" },
        { title: "انتقال سهام عدالت متوفیان", link: "/deceased" },
      ],
    },
    kalaReport: {
      title: "آمارمعاملات",
      Breadcrumbs: [
        { title: "خانه", link: "/" },
        { title: "آمارمعاملات", link: "/kalaReport" },
      ],
    },
    oragh: {
      title:'بورس اوراق بهادار',
      bg_lg: '/assets/images/newImages/Investment.jpg',
      bg_sm: '/assets/images/newImages/Investment414.jpg',
      Breadcrumbs: [
        { title: "خانه", link: "/" },
        { title: "بورس اوراق بهادار", link: "/oragh" },
      ],
    },
  };

  useEffect(() => {
    let url = window.location.pathname.replace("/", "");
    setstate(url);
  }, [window.location.pathname]); //eslint-disable-line  react-hooks/exhaustive-deps


  useEffect(() => {
    if (obj[state]?.title) {
      document.title = `${obj[state]?.title}- وب سایت کارگزاری پویان`;
    }else{
      document.title = `وب سایت کارگزاری پویان`;
    }
  }, [state,window.location.pathname]); 


  return (
    <div className={classes["root"]}>
      <div className={classes["grid"]}>
        <Breadcrumbs data={obj[state]} />
        <div className={classes["cardTitle"]}>

          {
            obj[state]?.title && (
              <div className={classes["title"]}>
                <h1>{obj[state]?.title}</h1>
                {/* <svg className={classes["icon"]}>
                  <use xlinkHref={"/sprit.svg#title-svg"}></use>
                </svg> */}
              </div>
            )
          }

        </div>
      </div>
      {/* <img
        src={
          obj[state]?.bg_lg
            ? !matches ? obj[state]?.bg_lg : obj[state]?.bg_sm
            : `/assets/images/${matches ? "stock-chart-414.png" : "stock-chart-1080.png"}`}
        alt={""}
        className={classes["bg"]}
      /> */}
      <div
        className={classes["bgImages"]}
        style={{
          background: `url(${obj[state]?.bg_lg
            ? !matches ? obj[state]?.bg_lg : obj[state]?.bg_sm
            : `/assets/images/${matches ? "stock-chart-414.png" : "stock-chart-1080.png"}`
            })`
          //     background: `url(${obj[state]?.bg_lg
          //       ? !matches ? obj[state]?.bg_lg : obj[state]?.bg_sm
          //       : `/assets/images/${matches ? "stock-chart-414.png" : "stock-chart-1080.png"}`}
          // })`
        }}
      ></div>
    </div>
  );
}
